<div class="container">

	<div class="form-loading" *ngIf='recordService.loading.value || cartService.addToCartLoading.value'>
		<span class='fa fa-spinner fa-spin'></span>
	</div>

	<div class="row">
		<div class="col-6 left-col">
			<slider *ngIf='product?.language_contents?.carousel_images.length'
				[carousel_images]='product.language_contents.carousel_images'
			></slider>
			<!-- fake img -->
			<img class="fake_img" *ngIf='!product?.language_contents?.carousel_images.length' src='assets/img/1024x768.png' />
		</div>

		<div class="col-6 right-col">
			<h1 class="title">{{product?.language_contents?.description}}</h1>

			<bdi class="price" *ngIf='product?.properties?.price.value && preview.isValid'>
				<span class="original_price" [class.line-through]='((product.properties.price.value * formGroup.controls["ADT"].value) > preview.response.total_amount) && !recordService.loading.value'>
					{{(product.properties.price.value * formGroup.controls["ADT"].value) | currency:'EUR'}}
				</span>
				<!-- discounted price -->
				<ng-container *ngIf='((product.properties.price.value * formGroup.controls["ADT"].value) > preview.response.total_amount) && !recordService.loading.value'>
					<span class="discounted-price">{{preview.response.total_amount | currency:'EUR'}}</span>
				</ng-container>
			</bdi>

			<div [innerHTML]='product?.language_contents?.full_description' class="text"></div>

			<div class="warning" *ngIf='!preview.isValid'>
				Non disponibile per la quantità indiciata
			</div>

			<div class="add-to-cart-wrapper">
				<form *ngIf='formGroup' id="product-form" autocomplete="off" [formGroup]='formGroup'>
					<!-- calendar -->
					<ng-container *ngIf='product?.allotment_type == "shared_allotment"'>
						<div class="calendar">
							<label><i class="icon-calendar-7"></i> {{'Seleziona una data' | translate}}</label>
							<div class="date-pick-wrapper">
								<input class="date-pick form-control" readonly='true' data-date-format="dd/mm/yyyy" type="text" formControlName="date" autocomplete="off" />
							</div>
						</div>
					</ng-container>
					<!-- add to cart -->
					<div class="add-to-cart-section">
						<div class="inner">
							<input type="button" title="Reduce Quantity" value="-" class="qty-minus" data-field="quantity" (click)='decrement()'>
							<input type="number" formControlName="ADT" min="1" step="1" value="0" class="qty" />
							<input type="button" title="Increase Quantity" value="+" class="qty-plus" data-field="quantity" (click)='increment()'>
						</div>

						<button [disabled]='!preview.isValid' class="add-to-cart-cta" (click)='addToCart()'>
							Aggiungi al carrello
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>